import React from 'react';
import { ChevronRight } from 'lucide-react';

interface FooterProps {
  setCurrentPage: (page: string) => void;
}

const Footer = ({ setCurrentPage }: FooterProps) => (
  <footer className="bg-gray-900">
    <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="col-span-1 md:col-span-2">
          <h3 className="text-white text-lg font-semibold mb-4">BottleCosts</h3>
          <p className="text-gray-400 text-sm">
            Streamlining beverage distribution and procurement for businesses across the country.
          </p>
        </div>
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Navigation</h3>
          <ul className="space-y-2">
            <li>
              <button onClick={() => setCurrentPage('home')} className="text-gray-400 hover:text-white text-sm">
                Home
              </button>
            </li>
            <li>
              <button onClick={() => setCurrentPage('buyers')} className="text-gray-400 hover:text-white text-sm">
                For Buyers
              </button>
            </li>
            <li>
              <button onClick={() => setCurrentPage('sellers')} className="text-gray-400 hover:text-white text-sm">
                For Sellers
              </button>
            </li>
            <li>
              <button onClick={() => setCurrentPage('contact')} className="text-gray-400 hover:text-white text-sm">
                Contact
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-white text-lg font-semibold mb-4">Account</h3>
          <ul className="space-y-2">
            <li>
              <a href="https://app.bottlecosts.com/login" className="text-gray-400 hover:text-white text-sm inline-flex items-center">
                Sign In
                <ChevronRight className="ml-1 h-4 w-4" />
              </a>
            </li>
            <li>
              <a href="https://app.bottlecosts.com/register" className="text-gray-400 hover:text-white text-sm inline-flex items-center">
                Sign Up
                <ChevronRight className="ml-1 h-4 w-4" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-8 pt-8 border-t border-gray-800">
        <p className="text-gray-400 text-sm text-center">
          © {new Date().getFullYear()} BottleCosts. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer; 